import { ApiRequestError } from "@nexxt/api-client";
import { QueryClient } from "@tanstack/react-query";

/** The cache of an app: data fresh for 30 s, and a 4xx is not asked again, since asking again will not change it. */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failures, error) => !(error instanceof ApiRequestError && error.status < 500) && failures < 2,
      },
    },
  });
